import { TextAreaField } from '../../atoms';
import { FORM_CLASSIFIERS_INVOICE_CONFIRMATION_EDIT } from '../../constants/formKeys';
import {
  getClassifiersInvoiceConfirmationChange,
  getClassifiersInvoiceConfirmationItemDataEn,
  getClassifiersInvoiceConfirmationItemDataEt,
  getClassifiersInvoiceConfirmationItem,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { classifierInvoiceConfirmationEditFields } from '../../constants/classifier';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'invoiceConfirmationTitle',
  formKey: FORM_CLASSIFIERS_INVOICE_CONFIRMATION_EDIT,
  fields: [
    {
      name: classifierInvoiceConfirmationEditFields.EN,
      label: 'fieldEn',
      component: TextAreaField,
      colSpan: 12,
      rows: 12,
    },
    {
      name: classifierInvoiceConfirmationEditFields.ET,
      label: 'fieldEt',
      component: TextAreaField,
      colSpan: 12,
      rows: 12,
    },
  ],
  fetchAction: actions.fetchClassifierInvoiceConfirmation,
  changeAction: actions.changeClassifierInvoiceConfirmation,
  getChangeSelector: getClassifiersInvoiceConfirmationChange,
  getItemSelector: getClassifiersInvoiceConfirmationItem,
  getInitialValues: (state) => ({
    [classifierInvoiceConfirmationEditFields.ET]:
      getClassifiersInvoiceConfirmationItemDataEt(state),
    [classifierInvoiceConfirmationEditFields.EN]:
      getClassifiersInvoiceConfirmationItemDataEn(state),
  }),
});
